/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Mitra_DescInputs */

const en_cp_p_mitra_desc = /** @type {(inputs: Cp_P_Mitra_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 40 teams, one-academic-year MoU. Everything in Class + lecturer training, 4 office hours per semester, end-of-semester report for leadership, co-branding, independent-study paperwork support.`)
};

const id_cp_p_mitra_desc = /** @type {(inputs: Cp_P_Mitra_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 40 tim, MoU 1 tahun akademik. Semua di Kelas + pelatihan dosen, office hours 4×/semester, laporan akhir ke pimpinan, co-branding, dukungan dokumen MBKM.`)
};

/**
* | output |
* | --- |
* | "≥ 40 teams, one-academic-year MoU. Everything in Class + lecturer training, 4 office hours per semester, end-of-semester report for leadership, co-branding, ..." |
*
* @param {Cp_P_Mitra_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_mitra_desc = /** @type {((inputs?: Cp_P_Mitra_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Mitra_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_mitra_desc(inputs)
	return en_cp_p_mitra_desc(inputs)
});